import { MapState } from "../phaser/map/MapState"
import { Month } from "./TimeUtils"

// Default dev state at /activities
// MainGame.ts

export const DEV_STATE = MapState

export const LOGIN_NAME = "31415"

export const LOGIN_ID = "31415"

export const BIRTHDAY_MONTH = Month.OCTOBER

export const BIRTHDAY_DAY = 31
